<template>
  <b-form @submit.prevent="onSubmitFn">
    <b-form-row>
      <b-col cols="3" class="col-form-label px-3">
        <label class="w-100 text-right">{{ $t('message.addressForm.label.street') }}
          <span class="text-danger">*</span>
        </label>
      </b-col>
      <b-col cols="9" class="px-3">
        <b-form-group
          :state="$v.address.street.$error ? false : null"
          :invalid-feedback="$t('error.addressForm.street')">
          <b-input
            class="rounded-0"
            v-model="address.street"
            :state="$v.address.street.$error ? false : null"
            @changed="$v.address.street.$touch()"/>
        </b-form-group>
      </b-col>
    </b-form-row>

    <b-form-row class="mt-3">
      <b-col cols="3" class="col-form-label px-3">
        <label class="w-100 text-right">{{ $t('message.addressForm.label.streetNumber') }}
          <span class="text-danger">*</span>
        </label>
      </b-col>
      <b-col cols="9" class="px-3">
        <b-form-group
          :state="$v.address.streetNumber.$error ? false : null"
          :invalid-feedback="$t('error.addressForm.streetNumber')">
          <b-input
            class="rounded-0"
            v-model="address.streetNumber"
            :state="$v.address.streetNumber.$error ? false : null"
            @changed="$v.address.streetNumber.$touch()"/>
        </b-form-group>
      </b-col>
    </b-form-row>

    <b-form-row class="mt-3">
      <b-col cols="3" class="col-form-label px-3">
        <label class="w-100 text-right">{{ $t('message.addressForm.label.additionalAddress') }}</label>
      </b-col>
      <b-col cols="9" class="px-3">
        <b-form-group>
          <b-input
            class="rounded-0"
            v-model="address.additionalAddress">
          </b-input>
        </b-form-group>
      </b-col>
    </b-form-row>

    <b-form-row class="mt-3">
      <b-col cols="3" class="col-form-label px-3">
        <label class="w-100 text-right">{{ $t('message.addressForm.label.postalCode') }}
          <span class="text-danger">*</span>
        </label>
      </b-col>
      <b-col cols="9" class="px-3">
        <b-form-group
          :state="$v.address.postalCode.$error ? false : null"
          :invalid-feedback="$t('error.addressForm.postalCode')">
          <b-input
            class="rounded-0"
            v-model="address.postalCode"
            :state="$v.address.postalCode.$error ? false : null"
            @changed="$v.address.postalCode.$touch()"/>
        </b-form-group>
      </b-col>
    </b-form-row>

    <b-form-row class="mt-3">
      <b-col cols="3" class="col-form-label px-3">
        <label class="w-100 text-right">{{ $t('message.addressForm.label.city') }}
          <span class="text-danger">*</span>
        </label>
      </b-col>
      <b-col cols="9" class="px-3">
        <b-form-group
          :state="$v.address.city.$error ? false : null"
          :invalid-feedback="$t('error.addressForm.city')">
          <b-input
            class="rounded-0"
            v-model="address.city"
            :state="$v.address.city.$error ? false : null"
            @changed="$v.address.city.$touch()"/>
        </b-form-group>
      </b-col>
    </b-form-row>
    <b-form-row class="mt-3">
      <b-col cols="3" class="col-form-label px-3">
        <label class="w-100 text-right">{{ $t('message.addressForm.label.country') }}
        </label>
      </b-col>
      <b-col cols="9" class="px-3">
        <b-form-group
          :state="$v.address.country.$error ? false : null"
          :invalid-feedback="$t('error.addressForm.country')">
          <b-input
            class="rounded-0"
            v-model="address.country"
            :state="$v.address.country.$error ? false : null"
            @changed="$v.address.country.$touch()"/>
        </b-form-group>
      </b-col>
    </b-form-row>
    <b-form-row>
            <b-col offset="3" class="col-form-label px-3 " >
            <div class="requieredFields text-right"  >
               <span v-html=" $t('message.contractPartnerDetails.label.requiredFields')"></span>
            </div>
            </b-col>
    </b-form-row>
  </b-form>
</template>

<script>
  import {maxLength, required} from 'vuelidate/lib/validators'

  export default {
    props: {
      address: {
        type: Object,
        required: true
      },
      onSubmitFn: {
        type: Function,
        required: true
      }
    },
    validations: {
      address: {
        street: {
          required
        },
        streetNumber: {
          required
        },
        additionalAddress: {
          maxLength: maxLength(325)
        },
        postalCode: {
          required
        },
        city: {
          required
        },
        country: {
          required
        }
      }
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/address/AddressForm.vue